 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTACK from '@/components/Text/ack'
 import TEXTTIMELINE from '@/components/Text/timeline'
 import TEXTDEDI from '@/components/Text/dedi'
 import TEXTCH01 from '@/components/Text/ch01'
 import TEXTCH02 from '@/components/Text/ch02'
 import TEXTCH03 from '@/components/Text/ch03'
 import TEXTCH04 from '@/components/Text/ch04'
 import TEXTCH05 from '@/components/Text/ch05'
 import TEXTCH06 from '@/components/Text/ch06'
 import TEXTCH07 from '@/components/Text/ch07'
 import TEXTCH08 from '@/components/Text/ch08'
 import TEXTCH09 from '@/components/Text/ch09'
 import TEXTCH10 from '@/components/Text/ch10'
 import TEXTAFTERWORD from '@/components/Text/afterword'
 import TEXTAUTHOR from '@/components/Text/author'
 import TEXTBM01 from '@/components/Text/bm01'
 import TEXTBC from '@/components/Text/bc'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/title",
 			"name" : "Text/title",
 			"component" : TEXTTITLE
 		},
 		{
 			"path" : "/Text/copyright",
 			"name" : "Text/copyright",
 			"component" : TEXTCOPYRIGHT
 		},
 		{
 			"path" : "/Text/ack",
 			"name" : "Text/ack",
 			"component" : TEXTACK
 		},
 		{
 			"path" : "/Text/timeline",
 			"name" : "Text/timeline",
 			"component" : TEXTTIMELINE
 		},
 		{
 			"path" : "/Text/dedi",
 			"name" : "Text/dedi",
 			"component" : TEXTDEDI
 		},
 		{
 			"path" : "/Text/ch01",
 			"name" : "Text/ch01",
 			"component" : TEXTCH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js